export * from "./enums.js";
export * from "./modifiers/index.js"; // eslint-disable-next-line import/no-unused-modules

export { popperGenerator, detectOverflow, createPopper as createPopperBase } from "./createPopper.js"; // eslint-disable-next-line import/no-unused-modules

export { createPopper } from "./popper.js"; // eslint-disable-next-line import/no-unused-modules

export { createPopper as createPopperLite } from "./popper-lite.js";


//////////////////
// WEBPACK FOOTER
// ./~/@popperjs/core/lib/index.js
// module id = 1320
// module chunks = 0